import Firebase from 'firebase/app';
import { useQuery } from 'Firebase';
import { InfoPart } from '/Info/InfoPart';

export const useInfoParts = (where: (query: Firebase.firestore.Query) => Firebase.firestore.Query): [InfoPart[] | null, () => Promise<void>] => {
	const [infoParts, fetch] = useQuery<InfoPart>('infoParts', where);
	return [infoParts, fetch];
};
